export default "__VITE_ASSET__CWMdO0CU__"